import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Observable } from 'rxjs';
import { AdminViewsService } from '../_services/admin-views.service';

@Component({
  selector: 'app-edit-manufacturers',
  templateUrl: './edit-manufacturers.component.html',
  styleUrls: ['./edit-manufacturers.component.css']
})
export class EditManufacturersComponent implements OnInit {
  id: string;
  manufacturers$ = this._adminService.manufacturers$;
  myManufacturers$ = this._adminService.myManufacturers$;
  selectedFramework: number[] = [];

  manufacturersForm: FormGroup;

  selectedFramework1: string[] = []

  private _loading: BehaviorSubject<boolean | null> = new BehaviorSubject(false);

  get loading$(): Observable<boolean> {
    return this._loading.asObservable();
  }


  constructor(
    private _adminService: AdminViewsService,
    private _formBuilder:FormBuilder,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef
    ) { }

  ngOnInit(): void {
    this.manufacturersForm = this._formBuilder.group({
        users_assigned    : [[]],
    });


      this._adminService.getUserManufacturers(this.id).subscribe(res=>{
        console.log(res);
        this.selectedFramework = res.map(res=>res.id);
        this.manufacturersForm.get('users_assigned').patchValue(this.selectedFramework);
      })


  }


  userCheck(user: any): boolean{
      const index = this.selectedFramework.findIndex(x=>x === user)
      if(index >= 0){
          return true;
      }else{
          return false;
      }
  }


  manufacturesChange(userId:number){
    const usersAssigned = this.manufacturersForm.get('users_assigned').value;
    const index = usersAssigned.findIndex(object => object === userId);
    if (index < 0) {
        usersAssigned.push(userId);
    }else{
        usersAssigned.splice(index,1);
    }
    this.manufacturersForm.get('users_assigned').patchValue(usersAssigned);
    console.log(this.manufacturersForm.get('users_assigned').value);
  }


  editmanufacturers(){
    this._loading.next(true)
    this._adminService.updateManufacturers(this.id, this.manufacturersForm.get('users_assigned').value).subscribe(res=>{
      console.log(res);
      this._loading.next(false)
    },err=>{
      this._loading.next(false)
    })
  }

}
